<div class="flex flex-col bg-white rounded-lg border border-gray-200 p-2">
    <label for="office-selector" class="text-[11px] font-semibold text-gray-500 ml-1">Oficina</label>
    <p-select inputId="office-selector" [options]="officesList" size="small" [(ngModel)]="officeSelected" [loading]="loading" optionLabel="name"  placeholder="Seleccionar Oficina" class="w-full">
        <ng-template #dropdownicon>
            <i class="pi pi-building"></i>
        </ng-template>
    </p-select>
</div>
